import {
    Row,
    Col,
    DatePicker,
    Input,
    Select,
} from 'antd';
import { IContext } from '../context/certifications.interface';

const { RangePicker }: any = DatePicker;
const { Search } = Input;

const Filters = ({
    searchParams,
    handleDate,
    handleSearch,
    handleStatus,
}: Partial<IContext>) => {
    const {
        search,
        status,
    } = searchParams;

    const STATUS = [
        { label: 'PENDING', value: 'PENDING' },
        { label: 'APPROVED', value: 'APPROVED' },
        { label: 'REJECTED', value: 'REJECTED' },
    ];

    return (
        <Row justify="start" gutter={[16, 24]}>
            <Col>
                {
                    handleDate && (
                        <RangePicker
                            onChange={(date: any = []) => {
                                if (date) {
                                    const [startDate, endDate] = date;
                                    handleDate([
                                        startDate.startOf('day').toISOString(),
                                        endDate.endOf('day').toISOString(),
                                    ]);
                                } else {
                                    handleDate([]);
                                }
                            }}
                        />
                    )
                }
            </Col>
            <Col>
                <Select
                    defaultValue={status}
                    mode="multiple"
                    style={{ width: '160px' }}
                    placeholder="Status"
                    onChange={handleStatus}
                    options={STATUS}
                    maxTagCount="responsive"
                />
            </Col>
            <Col>
                <Search
                    allowClear
                    enterButton
                    style={{ width: '350px' }}
                    placeholder="Search by workspace or workspaceUniqueID"
                    defaultValue={search}
                    onSearch={handleSearch}
                />
            </Col>
        </Row>
    );
};

export default Filters;
